import { TAX_CODES_QUERY } from "@/apis/gql/apolloClient";
import type { TaxCode } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { useQuery } from "@apollo/client";

export const useGetAllTaxCodes = () => {
  const { tenantId } = useTenant();
  const { data, error, loading, refetch } = useQuery<{
    taxCodes: TaxCode[];
  }>(TAX_CODES_QUERY, {
    variables: { tenantId },
  });

  return { taxCodes: data?.taxCodes ?? [], error, loading, refetch };
};
